import { Component, OnInit } from '@angular/core';
import { PfsService } from 'src/app/services/pfs.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-pfs-holdings-list',
  templateUrl: './pfs-holdings-list.component.html',
  styleUrls: ['./pfs-holdings-list.component.css']
})
export class PfsHoldingsListComponent {
  columnDefs = [
    { field: 'id' },
    { field: 'name' },
    { field: 'data_source' },
    { field: 'type' },
    { field: 'value' },
    { field: 'updated_at' }
  ];

  rowData: any[] = [];

  constructor(private pfsService: PfsService, private authService: AuthService) {}

  ngOnInit(): void {
    this.authService.getToken().subscribe((token: any) => {
      this.pfsService.getHoldingsByClient(99, token).subscribe((data: any[]) => {
        this.rowData = data;
      });
    });
  }
}
